
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import type { AttributeStatsModel, BonusesMapping, ElementKind } from "@/cuties/model/pet/PetModelData";
    import { ALL_ELEMENTS, getStatsDict } from "@/cuties/pet/PetService";
    import { formatStat } from "@/cuties/model/adventure/BonusUseInfo";
    import FormatStat from "@/app/components/stat/FormatStat.vue";
    import type { BonusKind } from "cuties-client-components/types/api/Cutie";

    type Stat = BonusKind;

    /**
     * note, it's very similar to the stats in `CutieCard.vue`,
     * possibly we would want to merge them into one component
     */
    @Component({
        components: { FormatStat },
    })
    export default class CutieCardStats extends Vue {
        @Prop({ required: true }) bonusesV2: AttributeStatsModel[];

        /**
         * possibly grid would make more sense than two flex rows, would be easier
         * to parametrize the number of columns and the list of displayed stats
         */
        statsMatrix: Stat[][] = [
            ["minAttack", "attack", "defence", "minDefence",],
            ["evasion", "criticalHit"],
            ["rewardDropChance", "exp", "raid"],
        ];

        elements = ALL_ELEMENTS;

        private get bonuses(): Partial<BonusesMapping> {
            return getStatsDict(this.bonusesV2);
        }

        getElementValue(element: ElementKind): number {
            return this.bonuses[element]?.bonus ?? 0;
        }

        formatStat(value: number, stat: Stat): string {
            return formatStat(value, stat);
        }

        getStatValueWithoutBuff(stat: Stat) {
            const found = this.bonusesV2.find((statData) => statData.kind == stat);
            let value = found?.value ?? 0;
            if (this.locationBuff(stat)) {
                // extract season buff value to show it separately as "+X"
                value -= parseFloat(this.locationBuff(stat));
            }
            return value;
        }

        findFormattedStatValue(stat: Stat): string {
            const shownValue = this.getStatValueWithoutBuff(stat);
            return this.formatStat(shownValue, stat);
        }

        locationBuff(stat: Stat, format = false, defaultValue = ""): string {
            const bonus = this.bonuses[stat];
            if (bonus && bonus.useInfos) {
                const sum = bonus.useInfos
                    .filter((element) => element.useKind == "ItemLocationBuff")
                    .map((el) => el.bonus)
                    .reduce((a, b) => +a + +b, 0);
                if (sum == 0) {
                    return defaultValue;
                }
                let res = sum.toString();

                if (format) {
                    res = this.formatStat(sum, stat);
                }
                return res ? res : defaultValue;
            }
            return defaultValue;
        }

        checkLocationBuff(stat: Stat): boolean {
            const bonus = this.bonuses[stat];
            if (bonus && bonus.useInfos) {
                return bonus.useInfos.some((element) => element.useKind == "ItemLocationBuff");
            }
        }
    }
